import { useContext } from 'react';

import { XYChartAxesFormatterContext } from '../context/axes/XYChartAxesFormatter.context.js';

export const useAxesFormatter = () => {
  const context = useContext(XYChartAxesFormatterContext);

  if (context === undefined) {
    throw new Error(
      'useAxesFormatter must be used within a XYChartAxesFormatterContext',
    );
  }

  return context;
};
